<template>
  <div class="career animatedBox">
    <div class="container fluid">
      <div class="card p-1">
        <fd-table
          :componentTitle="'Careers Request'"
          :tableButton="actionButton"
          :indexed="true"
          :plugin="{
            search: [1, 2],
          }"
          :searchBarTitle="'Search from First Name...'"
          :getFunction="getAllCareer"
        ></fd-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "career",
  data() {
    return {
      actionButton: [
        {
          title: "View",
          class: "update",
          routerLink: "/career/detail",
        },
      ],
    };
  },
  methods: {
    async getAllCareer(keyword, currentPage, perPage, isLoading) {
      const request = await this.$store.dispatch("career/getAllCareer", {
        keyword: keyword,
        currentPage: currentPage,
        perPage: perPage,
        isLoading: isLoading,
      });

      return request;
    },
  },
};
</script>

<style>
.career {
}
</style>